import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { TenantPage } from 'layouts';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { equipmentInvoiceLineService } from 'shared/services';
import { EquipmentInvoiceLinesColumns } from '../equipment-invoice-lines';

export function ExpectedEquipmentInvoices() {
  const { t } = useTranslation();
  const translationPrefix = 'pages.equipment-invoices.list';
  const datagridRefresh = useRef(null);

  const columns = EquipmentInvoiceLinesColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={equipmentInvoiceLineService}
        getMethod={equipmentInvoiceLineService.getUnassigned}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
}

export default ExpectedEquipmentInvoices;
